import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";

const ThankYou = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "/";
    }, 30000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex items-center justify-center h-screen shadow-2xl  rounded-2xl  text-white">
      <div className="max-w-lg p-6 text-center shadow-xl bg-[#2A2A2A] rounded-2xl mt-[-250px]">
        <FontAwesomeIcon
          icon={faCircleCheck}
          className="text-green-400 w-16 h-16 mx-auto mb-4"
        />{" "}
        <h1 className="text-2xl font-bold text-white">
          Verify Your Email to Get Started
        </h1>
        <p className="text-m pt-4">
          A verification link has been sent to your email, plaese verify your
          account before logging in.
        </p>
        <a
          className="px-6 mt-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition inline-block"
          href="/"
        >
          Go to Home Page
        </a>
      </div>
    </div>
  );
};

export default ThankYou;
